var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Button } from '@app/Components/Button/Button';
import styles from './ApproveDenyDeliverableButtons.module.scss';
import { Api } from '@app/Api';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
export var ApproveDenyDeliverableButtons = /** @class */ (function (_super) {
    __extends(ApproveDenyDeliverableButtons, _super);
    function ApproveDenyDeliverableButtons(props) {
        var _this = _super.call(this, props) || this;
        _this.loading = false;
        _this._onApproveButtonClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var deliverable, deliverableApproverId, canApproveWithoutApprover;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        deliverable = (_a = this.props, _a.deliverable), deliverableApproverId = _a.deliverableApproverId, canApproveWithoutApprover = _a.canApproveWithoutApprover;
                        if (!deliverable) return [3 /*break*/, 4];
                        if (!deliverableApproverId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._handleApprove(deliverable.id, deliverableApproverId)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!canApproveWithoutApprover) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._handleApprove(deliverable.id)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this._handleApprove = _this._handleApprove.bind(_this);
        return _this;
    }
    ApproveDenyDeliverableButtons.prototype._handleApprove = function (id, approvalId) {
        var _a, _b;
        if (approvalId === void 0) { approvalId = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, , 2, 3]);
                        this.loading = true;
                        return [4 /*yield*/, Api.secured.approveDeliverable(id, { approvalId: approvalId })];
                    case 1:
                        _c.sent();
                        (_b = (_a = this.props).onApprovedHandler) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [3 /*break*/, 3];
                    case 2:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApproveDenyDeliverableButtons.prototype.render = function () {
        var _a;
        var _this = this;
        var isApproveDisabled = (_a = this.props, _a.isApproveDisabled), isDenyDisabled = _a.isDenyDisabled, hideApproveButton = _a.hideApproveButton, hideDenyButton = _a.hideDenyButton, parentClassName = _a.parentClassName, childClassName = _a.childClassName, disabled = _a.disabled;
        return (React.createElement("div", { className: "".concat(styles.actions, " ").concat(parentClassName) },
            React.createElement(Button, { className: "".concat(styles.action, " ").concat(childClassName), size: "sm", color: "success", onClick: this._onApproveButtonClick, disabled: isApproveDisabled || this.loading || disabled, style: { visibility: hideApproveButton ? 'hidden' : 'visible' } }, "Approve"),
            React.createElement(Button, { className: "".concat(styles.action, " ").concat(childClassName), size: "sm", onClick: function () {
                    _this.props.onDenyHandler();
                }, isLoading: this.loading, disabled: isDenyDisabled || disabled, style: { visibility: hideDenyButton ? 'hidden' : 'visible' } }, "Deny")));
    };
    __decorate([
        observable
    ], ApproveDenyDeliverableButtons.prototype, "loading", void 0);
    ApproveDenyDeliverableButtons = __decorate([
        observer
    ], ApproveDenyDeliverableButtons);
    return ApproveDenyDeliverableButtons;
}(React.Component));
